import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import { Transition } from 'react-transition-group';
import IconButton from "../CTA/IconButton";
import { PlayVideoIcon, PauseVideoIcon } from "../Icon";
import styles from './PlayVideoToggleButton.module.scss';
const PlayVideoToggleButton = ({ isPlaying, isTouchDevice, labels, onVideoClickEvent, title, }) => {
    let timeout;
    useEffect(() => {
        // clear timout on unmount
        return () => clearTimeout(timeout);
    }, []);
    const [isHovering, setIsHovering] = useState(false);
    const [isPressed, setIsPressed] = useState(false);
    const overlayRef = useRef(null);
    const handleOnClick = (event) => {
        event.stopPropagation();
        onVideoClickEvent();
        setIsPressed(!isPressed);
    };
    const handleOnMouseMoveEvent = () => {
        clearTimeout(timeout);
        if (!isHovering) {
            setIsHovering(true);
        }
        timeout = setTimeout(() => setIsHovering(false), 200);
    };
    return (React.createElement("div", { onClick: handleOnClick, className: styles.videoOverlay, onMouseMove: !isTouchDevice ? handleOnMouseMoveEvent : undefined, role: "button", "aria-pressed": isPressed, onKeyPress: (e) => {
            return e.key === '14' && null;
        }, tabIndex: -1, title: title, ref: overlayRef, "data-testid": "playVideoToggleOverlay" },
        React.createElement(Transition, { in: !isPlaying || isHovering, timeout: { enter: 0, exit: 800 } }, (transitionState) => (React.createElement("div", { className: cn(styles.playVideoToggleButton, styles[transitionState]) },
            React.createElement(IconButton, { onClick: handleOnClick, title: title, iconElement: !isPlaying ? (React.createElement(PlayVideoIcon, { size: "large", className: styles.playIcon })) : (React.createElement(PauseVideoIcon, { size: "large", className: styles.pauseIcon })), className: styles.videoControllButton }, isPlaying ? labels.pauseButtonText : labels.playButtonText))))));
};
export default PlayVideoToggleButton;
//# sourceMappingURL=PlayVideoToggleButton.js.map